"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/components/SignupStepWrapper/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _types = require('web/screens/Signup/types');
var _AuthFrame = require('web/components/AuthFrame');
var _NavItem = require('./NavItem'); var _NavItem2 = _interopRequireDefault(_NavItem);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);



































const GROUPS = [
  { name: 'Account', lowerBound: _types.SetupSteps.PERSONAL_INFO, upperBound: _types.SetupSteps.PASSWORD, isLocked: true },
  { name: 'Organization', lowerBound: _types.SetupSteps.ORG_INFO, upperBound: _types.SetupSteps.ORG_INFO },
  { name: 'About your practice', lowerBound: _types.SetupSteps.ORG_SURVEY_REFERRER, upperBound: _types.SetupSteps.ORG_SURVEY_REFERRER, isSurvey: true },
  { name: 'Plan & agreements', lowerBound: _types.SetupSteps.PRODUCT_INTEREST, upperBound: _types.SetupSteps.TRIAL_OFFER, isSurvey: true },
  { name: 'Ready to go', lowerBound: _types.SetupSteps.FINISH, upperBound: _types.SetupSteps.FINISH },
]

// Layout a (D-2): the progress is a fixed row on the background and every
// card's top edge sits at the same height, so nothing jumps between steps.
const SignupStepWrapper = ({
  currentStep = _types.SetupSteps.PERSONAL_INFO,
  maxStep = currentStep,
  title = 'Sign-up',
  className,
  gotoStep,
  size = 'sm',
  showSurveySteps = true,
  showProgress = true,
  below,
  children,
}) => {
  const groups = GROUPS.filter(g => showSurveySteps || !g.isSurvey)
  const activeIndex = Math.max(0, groups.findIndex(
    g => currentStep >= g.lowerBound && currentStep <= g.upperBound,
  ))

  const progress = (
    _react2.default.createElement('nav', { className: "signup-step--nav", 'aria-label': `${title} progress`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
      ,  groups.map((g, i) => (
        _react2.default.createElement(_react2.default.Fragment, { key: g.name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
          ,  i > 0 && _react2.default.createElement('span', { className: "signup-step--nav-sep", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}} ) 
          , _react2.default.createElement(_NavItem2.default, {
            index: i + 1,
            name: g.name,
            gotoStep: g.isLocked ? null : gotoStep,
            lowerBound: g.lowerBound,
            upperBound: g.upperBound,
            currentStep: currentStep,
            maxStep: maxStep, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
          )
        )
      ))
    )
  )

  // Phone: bars and "Step n of 5 · name". Each breakpoint shows only one of
  // the two, so a screen reader meets the progress once.
  const phoneProgress = (
    _react2.default.createElement('div', { className: "signup-step--phone-progress", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
      , _react2.default.createElement('div', { className: "signup-step--phone-progress--bars", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
        ,  groups.map((g, i) => (
          _react2.default.createElement('i', {
            key: g.name,
            className: _classBuilder2.default.call(void 0, 
              i < activeIndex && 'done',
              i === activeIndex && 'on',
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
          )
        ))
      )
      , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, "Step " ,  activeIndex + 1 , " of "  ,  groups.length , " · "  ,  _optionalChain([groups, 'access', _ => _[activeIndex], 'optionalAccess', _2 => _2.name]) )
    )
  )

  return (
    _react2.default.createElement(_AuthFrame.AuthFrame, {
      align: "top",
      size: size,
      className: "signup-step-wrapper",
      cardClassName: _classBuilder2.default.call(void 0, 'signup-step--content', className),
      progress: showProgress ? progress : undefined,
      phoneProgress: showProgress ? phoneProgress : undefined,
      below: below,
      scrollKey: currentStep, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}

      ,  children 
    )
  )
}

exports. default = SignupStepWrapper
